function freeShippingBarInit() {
  var THRESHOLD_CENTS = 5000;
  var GIFT_CENTS = 10000;
  var GIFT_START = Date.parse('2026-10-28T00:00:00+11:00');
  var KEYS = [45818562412740,45819052163268,45818940424388,45819080310980,45818939703492,45818935083204,45818954711236,45818944454852];
  var keyProducts = null;
  var busy = false;
  var lastCartTotal = null;
  function giftLive() { return Date.now() >= GIFT_START; }
  function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }
  function isKey(it) { return KEYS.indexOf(it.variant_id) > -1; }
  function isAutoGift(it) { return it.properties && it.properties._free_gift; }
  function giftSpend(cart) { var s = 0; cart.items.forEach(function (it) { if (!isKey(it)) s += it.final_line_price; }); return s; }
  function hasKey(cart) { return cart.items.some(isKey); }
  function barHtml(totalCents) {
    var remaining = THRESHOLD_CENTS - totalCents;
    var pct = Math.max(0, Math.min(100, (totalCents / THRESHOLD_CENTS) * 100));
    var msg = remaining > 0 ? ('Add ' + formatMoney(remaining) + ' more for FREE delivery') : 'You have unlocked FREE delivery';
    var out = '';
    out += '<div class="fsb-msg">' + msg + '</div>';
    out += '<div class="fsb-track"><div class="fsb-fill" style="width:' + pct + '%"></div></div>';
    return out;
  }
  function giftHtml(cart) {
    var sp = giftSpend(cart);
    var rem = GIFT_CENTS - sp;
    var pct = Math.max(0, Math.min(100, (sp / GIFT_CENTS) * 100));
    var out = '';
    if (rem > 0) {
      out += '<div class="fsb-msg">🎁 Only <strong>' + formatMoney(rem) + '</strong> more and a little gift is on us</div>';
    } else if (hasKey(cart)) {
      out += '<div class="fsb-msg">🎉 <strong>Your free gift is in your cart.</strong> A little something, on us.</div>';
    } else {
      out += '<div class="fsb-msg">🎁 <strong>You unlocked a free gift!</strong> Choose yours:</div>';
    }
    out += '<div class="fsb-track"><div class="fsb-fill fgb-fill" style="width:' + pct + '%"></div></div>';
    if (rem <= 0 && !hasKey(cart)) out += '<div class="fgb-pick"></div>';
    return out;
  }
  function loadPicker(bar) {
    var pick = bar.querySelector('.fgb-pick');
    if (!pick) return;
    function render() {
      pick.innerHTML = keyProducts.map(function (p) {
        var v = p.variants && p.variants[0];
        var img = p.images && p.images[0] ? p.images[0].src.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') : '';
        return '<button type="button" class="fgb-item" data-id="' + v.id + '" title="' + p.title.replace(/"/g, '') + '"><img src="' + img + '" alt="" width="56" height="56"></button>';
      }).join('');
    }
    if (keyProducts) { render(); return; }
    fetch('/collections/evil-eye-keyring/products.json?limit=12').then(function (r) { return r.json(); }).then(function (d) { keyProducts = d.products || []; render(); }).catch(function () {});
  }
  function placeBar(container, referenceNode, cls) {
    if (!container) return null;
    var bar = container.querySelector('.' + cls);
    if (!bar) {
      bar = document.createElement('div');
      bar.className = cls;
      if (cls === 'free-gift-bar') bar.className += ' free-shipping-bar';
      if (referenceNode && referenceNode.parentNode === container) {
        container.insertBefore(bar, referenceNode);
      } else {
        container.appendChild(bar);
      }
    }
    return bar;
  }
  function autoRemove(cart) {
    if (!giftLive() || busy) return;
    if (giftSpend(cart) >= GIFT_CENTS) return;
    for (var i = 0; i < cart.items.length; i++) {
      if (isKey(cart.items[i]) && isAutoGift(cart.items[i])) {
        busy = true;
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: i + 1, quantity: 0 }) }).then(function () { location.reload(); }).catch(function () { busy = false; });
        return;
      }
    }
  }
  function loadAfterpay() {
    if (document.getElementById('afterpay-js')) return;
    var s = document.createElement('script');
    s.id = 'afterpay-js';
    s.async = true;
    s.src = 'https://js.afterpay.com/afterpay-1.x.js';
    document.head.appendChild(s);
  }
  function apEl(amount) {
    var el = document.createElement('afterpay-placement');
    el.className = 'ap-box';
    el.setAttribute('data-locale', 'en_AU');
    el.setAttribute('data-currency', 'AUD');
    el.setAttribute('data-amount', amount.toFixed(2));
    el.setAttribute('data-size', 'md');
    el.setAttribute('data-badge-theme', 'black-on-mint');
    el.setAttribute('data-logo-type', 'badge');
    return el;
  }
  function apPrice() {
    var el = document.querySelector('.price-area .current-price, .price-area .price');
    if (!el) return null;
    var n = parseFloat(el.textContent.replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : n;
  }
  function afterpayProduct() {
    if (location.pathname.indexOf('/products/') !== 0) return;
    var amt = apPrice();
    if (amt === null || amt < 1) return;
    var ex = document.querySelector('.ap-box.ap-product');
    if (ex) {
      if (ex.getAttribute('data-amount') !== amt.toFixed(2)) ex.setAttribute('data-amount', amt.toFixed(2));
      return;
    }
    var anchor = findShipBox();
    var form = document.querySelector('form[action*="/cart/add"]');
    var el = apEl(amt);
    el.className = 'ap-box ap-product';
    if (anchor && anchor.parentNode) { anchor.parentNode.insertBefore(el, anchor); }
    else if (form && form.parentNode) { form.parentNode.insertBefore(el, form.nextSibling); }
    else return;
    loadAfterpay();
  }
  function afterpayCart(totalCents) {
    var row = document.querySelector('.under-cart .subtotal-row');
    if (!row || totalCents < 100) return;
    var ex = document.querySelector('.ap-box.ap-cart');
    var amt = totalCents / 100;
    if (ex) { if (ex.getAttribute('data-amount') !== amt.toFixed(2)) ex.setAttribute('data-amount', amt.toFixed(2)); return; }
    var el = apEl(amt);
    el.className = 'ap-box ap-cart';
    row.parentNode.insertBefore(el, row.nextSibling);
    loadAfterpay();
  }
  function updateBars(cart) {
    var totalCents = cart.total_price;
    var modalInner = document.querySelector('#added-to-cart .inner');
    var cartTitle = document.querySelector('.template-cart h1');
    var spots = [];
    if (modalInner) spots.push({ c: modalInner, ref: modalInner.querySelector('p.links') });
    if (cartTitle && cartTitle.parentNode) spots.push({ c: cartTitle.parentNode, ref: cartTitle.nextSibling });
    spots.forEach(function (s) {
      var bar = placeBar(s.c, s.ref, 'free-shipping-bar-main');
      bar.className = 'free-shipping-bar free-shipping-bar-main';
      bar.innerHTML = barHtml(totalCents);
      if (giftLive()) {
        var g = placeBar(s.c, bar.nextSibling, 'free-gift-bar');
        g.innerHTML = giftHtml(cart);
        loadPicker(g);
      }
    });
    afterpayCart(totalCents);
    autoRemove(cart);
  }
  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) { updateBars(cart); }).catch(function () {});
  }
  function injectStyle() {
    if (document.getElementById('free-shipping-bar-style')) return;
    var style = document.createElement('style');
    style.id = 'free-shipping-bar-style';
    style.textContent = '.free-shipping-bar{margin:0 0 16px;padding:12px 14px;background:#f4f4f2;border-radius:8px;font-size:13px;text-align:center;}.free-shipping-bar .fsb-msg{margin-bottom:8px;}.free-shipping-bar .fsb-track{height:6px;border-radius:3px;background:#ddd;overflow:hidden;}.free-shipping-bar .fsb-fill{height:100%;background:#2fa288;transition:width .3s ease;}.free-gift-bar{background:#fbf3e4!important;border:1px solid #ecd9b0}.free-gift-bar .fgb-fill{background:#c9972f!important}.fgb-pick{display:flex;flex-wrap:wrap;gap:8px;justify-content:center;margin-top:12px}.fgb-item{border:2px solid transparent;background:#fff;padding:2px;border-radius:8px;cursor:pointer;line-height:0}.fgb-item:hover{border-color:#c9972f}.fgb-item img{border-radius:6px;object-fit:cover}.fg-box{margin-top:12px;padding:16px 18px;background:#fbf3e4;border:1px solid #ecd9b0;border-radius:8px;font-size:14px;line-height:1.5;color:#4a3a1f;display:flex;gap:12px;align-items:flex-start}.fg-box .fg-ic{font-size:22px;line-height:1.2}.fg-box strong{display:block;font-size:15px;color:#6b2331}.fg-home{display:block;margin-top:22px;font-size:11px;letter-spacing:.28em;text-transform:uppercase;color:#d9a04a}.fg-strip{background:#6b2331;color:#f6d58a;text-align:center;padding:12px 16px;font-size:13px;letter-spacing:.14em;text-transform:uppercase;font-weight:600}.fg-pill{display:block;width:100%;box-sizing:border-box;margin:4px 0 18px;padding:12px 20px;background:#6b2331;color:#f6d58a;border-radius:999px;text-align:center;font-size:15px;line-height:1.35;font-weight:600;letter-spacing:.16em;text-transform:uppercase;box-shadow:0 0 0 0 rgba(201,151,47,.55);animation:fgpulse 2.6s ease-out infinite}@keyframes fgpulse{0%{box-shadow:0 0 0 0 rgba(201,151,47,.55)}70%{box-shadow:0 0 0 12px rgba(201,151,47,0)}100%{box-shadow:0 0 0 0 rgba(201,151,47,0)}}@media(max-width:600px){.fg-pill{font-size:13px;letter-spacing:.12em;padding:11px 16px}}@media(prefers-reduced-motion:reduce){.fg-pill{animation:none}}.ap-box{display:block;margin:14px 0}';
    document.head.appendChild(style);
  }
  function findShipBox() {
    var strongs = document.querySelectorAll('strong');
    for (var i = 0; i < strongs.length; i++) {
      if (strongs[i].textContent.indexOf('Order today') === 0) return strongs[i].parentNode && strongs[i].parentNode.parentNode;
    }
    return null;
  }
  function stray() {
    var ship = findShipBox();
    if (!ship) return;
    var p = ship.previousSibling;
    if (p && p.nodeType === 3 && p.textContent.trim() === '}') p.parentNode.removeChild(p);
  }
  function productBox() {
    stray();
    afterpayProduct();
    if (!giftLive() || location.pathname.indexOf('/products/') !== 0) return;
    var ship = findShipBox();
    if (!ship || !ship.parentNode) return;
    var ttl = document.querySelector('.product-area__details__title');
    if (ttl && ttl.parentNode && !document.querySelector('.fg-pill')) {
      var pill = document.createElement('div');
      pill.className = 'fg-pill';
      pill.textContent = '🎁 Free gift with every order over $100';
      ttl.parentNode.insertBefore(pill, ttl.nextSibling);
    }
    if (document.querySelector('.fg-box')) return;
    var box = document.createElement('div');
    box.className = 'fg-box';
    box.innerHTML = '<span class="fg-ic">🎁</span><div><strong>A little gift, on us.</strong>Spend $100 or more and choose a free handmade gift to go with your order.</div>';
    ship.parentNode.insertBefore(box, ship.nextSibling);
  }
  function homeLine() {
    if (!giftLive()) return;
    var c = document.querySelector('.cn-copy');
    if (c) {
      if (!c.querySelector('.fg-home')) {
        var s = document.createElement('span');
        s.className = 'fg-home';
        s.textContent = '🎁 A free gift with every order over $100';
        c.appendChild(s);
      }
      return;
    }
    var m = document.getElementById('page-content');
    if (m && (location.pathname === '/' || location.pathname === '') && !document.querySelector('.fg-strip')) {
      var st = document.createElement('div');
      st.className = 'fg-strip';
      st.textContent = '🎁 A little gift on us — free with every order over $100';
      m.insertBefore(st, m.firstChild);
    }
  }
  function listStrip() {
    if (!giftLive()) return;
    var p = location.pathname;
    if (p.indexOf('/collections') !== 0 && p.indexOf('/search') !== 0) return;
    if (p.indexOf('/collections/evil-eye-keyring') === 0) return;
    var m = document.getElementById('page-content');
    if (!m || document.querySelector('.fg-strip')) return;
    var st = document.createElement('div');
    st.className = 'fg-strip';
    st.textContent = '🎁 Free gift with every order over $100';
    m.insertBefore(st, m.firstChild);
  }
  function watchForChanges() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (t && t.closest && (t.closest('.free-shipping-bar') || t.closest('.ap-box'))) { continue; }
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          refresh();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[name="updates[]"], input[type="number"]')) {
        setTimeout(refresh, 300);
      }
    });
    document.addEventListener('click', function (e) {
      var pick = e.target.closest ? e.target.closest('.fgb-item') : null;
      if (pick) {
        e.preventDefault();
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(pick.getAttribute('data-id')), quantity: 1, properties: { _free_gift: 'yes' } }] }) }).then(function () { location.reload(); });
        return;
      }
      var el = e.target.closest ? e.target.closest('a[href*="/cart/change"], .cart-remove, [data-cart-remove], button[name="update"]') : null;
      if (el) setTimeout(refresh, 300);
    });
  }
  injectStyle();
  refresh();
  watchForChanges();
  productBox();
  homeLine();
  listStrip();
  setTimeout(function () { productBox(); homeLine(); listStrip(); }, 1500);
  setInterval(afterpayProduct, 1200);
}
document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', freeShippingBarInit) : freeShippingBarInit();
